module.exports = __webpack_public_path__ + "static/media/courier.0b0e14e0.svg";